/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-void */
import { useState, useContext, useEffect } from 'react';
import {
  Typography,
  Container,
  Box,
  Card,
  CardContent,
  CardMedia,
  InputLabel,
  FormControl,
  Select,
  SelectChangeEvent,
  TextField,
  MenuItem,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { Link } from "react-router-dom"

import { ROLE_KEYS, useUserRole } from '../../../utils/awsConfigure';
import useNotification from "../../../utils/notificationUtil";
import { findFingertip } from '../../../utils/awsAmplifyUtil'
import { FingertipDocument } from '../types/pj1dbApiFingertip'
import { FormFingertipSearchCond } from '../types/fingertipForm'
import { DataStoreContext, CONTEXT_ACTION_TYPE } from "../contexts/EquipmentContext";
import { EQUIPMENT_URLS } from '../../../constants/constants'
import { handleInputChange, handleInputChangeSelect} from "../../../utils/formUtil"

import Pjdb1Button from '../../../components/inputs/Pjdb1Button';

const IMAGE_WIDTH = 240;
const IMAGE_HEIGHT = 240;
const CARD_HEIGHT = IMAGE_HEIGHT + 55;

export default function FingertipList() {
  const { userRole, userDomain } = useUserRole();

  const { infoMsg, errorMsg } = useNotification();
  const { state, dispatch } = useContext(DataStoreContext);

  const [isLoading, setIsLoading] = useState(false);

  const [ searchCond, setSearchCond] = useState<FormFingertipSearchCond>({
    keyword:"",
    listCount:0,
    sortOrder:"name",
  });

  const [fingertipList, setFingertipList] = useState<FingertipDocument[]>([]);
  const [notFoundMsg, setNotFoundMsg] = useState("");

  const sortList = (fingertipListData:FingertipDocument[],sortOrder:string):FingertipDocument[] => {
    let list = fingertipListData;
    if(sortOrder==="name"){
      list = list.sort((a,b) => a.attr.fingertipInfo.name.localeCompare(b.attr.fingertipInfo.name));
    }else if(sortOrder==="producer"){
      list = list.sort((a,b) => a.attr.fingertipInfo.producer.localeCompare(b.attr.fingertipInfo.producer));
    }else if(sortOrder==="latest"){
      list = list.sort((a,b) => b.attr.registrationDate - a.attr.registrationDate );
    }
    return list;
  }

  const findFingertipProc = async () => {
    setIsLoading(true);
    try {
      let query = {};
      if (searchCond.keyword !== "") {
        query = {
          "$or": [
            {"fingertipInfo.name":{ "$regex" : searchCond.keyword, "$options":"i" }},
            {"fingertipInfo.number":{ "$regex" : searchCond.keyword, "$options":"i" }},
            {"fingertipInfo.producer":{ "$regex"  :searchCond.keyword, "$options":"i" }},
            {"productInfo.keyword":{ "$regex"  :searchCond.keyword, "$options":"i" }},
            {"productInfo.description":{ "$regex"  :searchCond.keyword, "$options":"i" }},
          ]
        };
      }
      if (ROLE_KEYS.ADMIN !== userRole) query = { ...query, "domain" : userDomain};
      const cond = Object.keys(query).length ? {"query":query} : {};

      const result = await findFingertip(cond);
      if(!result.isSuccess){
        errorMsg("検索処理が失敗しました。");
        return;
      }
      // console.log(result);
      if(result.data && Object.entries(result.data).length > 0){
        const fingertipListData:FingertipDocument[] = Object.entries(result.data).map(([,handDoc])=>(handDoc));
        setFingertipList(sortList(fingertipListData, searchCond.sortOrder));
        setSearchCond({...searchCond, listCount:fingertipListData.length});
        dispatch({ type: CONTEXT_ACTION_TYPE.FINGERTIP_LIST, payload: {
          searchCond:{...searchCond,listCount:fingertipListData.length},
          fingertipList:fingertipListData,
        }});
      }else{
        setFingertipList([]);
        setNotFoundMsg("該当データがありません。");
      }
      infoMsg("検索しました。");
    } finally {
      setIsLoading(false);
    }
  }

  const changeSortOrder = (event:SelectChangeEvent<string>) => {
    handleInputChangeSelect<FormFingertipSearchCond>(event, "sortOrder",searchCond, setSearchCond);
    setFingertipList(sortList(fingertipList,event.target.value));
    dispatch({ type: CONTEXT_ACTION_TYPE.FINGERTIP_LIST, payload: {
      searchCond:{...searchCond,sortOrder:event.target.value},
      fingertipList,
    }});
  }

  // 検索済みデータの復元
  useEffect(()=>{
    if(state.fingertipListPage.fingertipList.length>0){
      // console.log("FingertipList","restore from context.",state);
      setSearchCond(state.fingertipListPage.searchCond);
      setFingertipList(state.fingertipListPage.fingertipList);
    }
    setNotFoundMsg("検索条件を入力し[検索]ボタンを押下してください。");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);


  return (
    <>
      <Container sx={{mt:2}} maxWidth={false}>
        <Card sx={{p:3}}>
          <Typography variant="subtitle1" sx={{fontWeight:"bold"}}>検索条件</Typography>
          <Box sx={{ml:2}}>
            <form onSubmit={(e)=>{
              e.preventDefault();
              void findFingertipProc();
            }}>
              <InputLabel variant='standard' sx={{mt:2,color: 'text.primary'}}>検索キーワード</InputLabel>

              <Grid container>
                <Grid size={{xs:5}}>
                  <TextField
                    label="製品名、製造者、型番、特徴などを入力"
                    name="keyword" value={searchCond.keyword}
                    variant="outlined" size="small"
                    margin="dense" fullWidth
                    onChange={(e)=>(handleInputChange<FormFingertipSearchCond>(e, searchCond, setSearchCond))}
                  />
                </Grid>
              </Grid>
              <Box sx={{mt:1}}>
                <Pjdb1Button
                  label="検索"
                  variant="contained"
                  color="primary"
                  isLoading={isLoading}
                  onClick={()=>{void findFingertipProc();}}
                />
              </Box>
            </form>
          </Box>
        </Card>
      </Container>

      <Container sx={{p:0, display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}} maxWidth={false}>

        <Grid container alignItems="end" sx={{mt:2,flexWrap:"nowrap"}} size={{xs:12}}>
          <Grid sx={{flexGrow:1}}>
            <Typography variant="subtitle1" sx={{fontWeight:"bold"}}>検索結果一覧</Typography>
          </Grid>
          <Grid>
            <Grid container alignItems="center" spacing={2} sx={{flexWrap:"nowrap"}}>
              <Grid>
                <Box component="span">
                  {searchCond.listCount > 0 ? `${searchCond.listCount.toLocaleString()}件` : ""}
                </Box>
              </Grid>
              <Grid>
                <Box component="span">
                  <FormControl sx={{minWidth:120}} size="small">
                    <InputLabel id="sort-order-label">並び順</InputLabel>
                    <Select
                      labelId="sort-order-label"
                      name="sortOrder"
                      value={searchCond.sortOrder}
                      label="並び順"
                      onChange={changeSortOrder}
                      sx={{bgcolor:"white"}}
                    >
                      <MenuItem value="name">製品名</MenuItem>
                      <MenuItem value="producer">製造者</MenuItem>
                      <MenuItem value="latest">最新</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container alignItems="start" spacing={2} sx={{mt:0,pt:2}} size={{xs:12}}>
        {fingertipList.map(row =>(
          <Grid key={row.attr.fingertipId}>
            <Link to={`${EQUIPMENT_URLS.FINGERTIP_DETAIL.URL}/${row.attr.fingertipId}`} style={{ textDecoration:'none' }}
            onClick={()=>{
              dispatch({ type: CONTEXT_ACTION_TYPE.TAB , payload: EQUIPMENT_URLS.FINGERTIP_DETAIL.TAB_IDX });
              dispatch({ type: CONTEXT_ACTION_TYPE.FINGERTIP_DETAIL , payload: {info:row} });
            }}>
              <Card sx={{ width:IMAGE_WIDTH, height:CARD_HEIGHT }}>
                <CardMedia
                  component="img"
                  height={IMAGE_HEIGHT}
                  image={row.url?.image[0]}
                  alt={row.attr._id}
                  sx={{objectFit:'contain'}}
                />
                <CardContent sx={{py:0.5,px:1,m:0}}>
                  <Typography variant="subtitle2" noWrap component='p' sx={{mt:0.5}}>
                    製品名：{row.attr.fingertipInfo.name}
                  </Typography>
                  <Typography variant="subtitle2" noWrap component='p' sx={{color:"#888"}}>
                    製造者：{row.attr.fingertipInfo.producer}
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          </Grid>
        ))}

        { (fingertipList.length===0) &&
          <Box sx={{my:3,width:"100%",textAlign:"center"}}>
            <Typography variant="subtitle1" sx={{fontWeight:"bold"}}>{notFoundMsg}</Typography>
          </Box>
        }
        </Grid>

      </Container>

    </>

  )
}